import React, { useEffect } from 'react';
import { useSelector } from 'react-redux';
import { useNavigate } from 'react-router-dom';
import { RootState } from '../../../../core/store/store';
import { usePanelAccess } from '../../context/PanelAccessContext';
import PanelHubGrid from '../../components/PanelHubGrid';

const PanelCmHubV1: React.FC = () => {
  const navigate = useNavigate();
  const { currentUser } = useSelector((state: RootState) => state.user);
  const { loading, hasAccessToSection } = usePanelAccess();
  const roleId = currentUser?.roles_id;
  const canEnterHub = hasAccessToSection('salon_cm');

  useEffect(() => {
    if (!loading && currentUser && !canEnterHub) {
      navigate('/panel/dashboard', { replace: true });
    }
  }, [loading, currentUser, canEnterHub, navigate]);

  if (!currentUser || loading || !canEnterHub || roleId !== 1) {
    return null;
  }

  return (
    <PanelHubGrid
      description="Accès complet plateforme : configuration, maintenance, sauvegardes, référent CM et rôles individuels."
      cards={[
        { to: '/panel/config', title: 'Configuration métier', description: 'Personnel, véhicules, bâtiments, compétences…', accent: 'amber' },
        { to: '/panel/cm/maintenance', title: 'Maintenance système', description: 'Mode maintenance et message public.', accent: 'amber' },
        { to: '/panel/system/backup', title: 'Sauvegardes', description: 'Backup et restauration serveur.', accent: 'slate' },
        { to: '/panel/cm/referent', title: 'Référent CM', description: 'Accès rôles, référents, codes invitation.', accent: 'sky' },
        { to: '/panel/roles/individual', title: 'Rôles individuels', description: 'Attributions rôles hors défaut global.', accent: 'violet' },
        { to: '/panel/roles/default-access', title: 'Accès panel par rôle', description: 'Matrice des sections pour chaque rôle.', accent: 'violet' },
        { to: '/panel/users/roles', title: 'Rôles utilisateurs', description: 'Changer le rôle d’un compte.', accent: 'sky' },
        {
          to: '/panel/players/premium',
          title: 'Statut premium (joueurs)',
          description: 'Gérer l’abonnement premium des comptes joueurs (sans leur donner le panel).',
          accent: 'emerald',
        },
        { to: '/panel/interventions/manage', title: 'Gestion scénarios', description: 'Interventions et scénarios CTA.', accent: 'cyan' },
        { to: '/panel/admin', title: 'Espace administrateur', description: 'Raccourcis admin.', accent: 'sky' },
        { to: '/panel/modo', title: 'Espace modérateur', description: 'Raccourcis modération.', accent: 'yellow' },
      ]}
      columns={2}
    />
  );
};

export default PanelCmHubV1;
